<template>
    <div class="home-content">
        <div class="bg-top"></div>
        <div class="device-info">
            <div class="device-no">
                <div>当前设备：{{device.deviceNo}}</div>
                <div class="device-status" :class="[device.status ? device.status.toLowerCase() : '']">{{device.status|statusName}}</div>
            </div>
            <div class="use-count">
                <div class="divider">
                    <div class="value">{{curMember.count}}</div>
                    <div class="label">剩余次数</div>
                </div>
                <div>
                    <div class="value">{{curMember.usedCount}}</div>
                    <div class="label">已用次数</div>
                </div>
            </div>
        </div>
        <div class="control-button">
            <button @click="handleControlButton" class="button-start" :class="{starting: isOpening}">{{isOpening ? '工作中' : '开启设备'}}</button>
            <div class="device-open-duration" v-if="isOpening && runDuration">已使用时长：{{runDuration}}</div>
            <div class="location-wrapper" v-if="locationRet === 'loading'"><van-icon name="location-o" /><span class="location-tip">正在定位中...</span></div>
            <div class="location-wrapper fail" v-else-if="locationRet === 'fail'"><van-icon name="location-o" /><span class="location-tip" @click="handleRelocation">定位失败，<a href="javascript:void(0)" class="relocation-button">重新定位</a></span></div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    // import {APP_ID} from "@/config";

    export default {
        name: "DeviceHome",
        data() {
            return {
                deviceStartTime: 0,
                runDuration: null,
                locationRet: undefined
            }
        },

        computed: {
            isOpening() {
                return this.device.runStatus === 'START';
            },
            curMember() {
                return this.members.find(item => item.id === this.selectMemberId) || {};
            },
            ...mapState([
                'members',
                'device',
                'selectMemberId'
            ])
        },
        watch: {
            device(value) {
                if (value.runStatus !== 'START'){
                    this.stopRunDurationTimer();
                }
            }
        },
        filters: {
            statusName(value) {
                if (!value) return '';
                switch (value.toLowerCase()) {
                    case 'offline': return '离线';
                    case 'online': return '在线';
                    case 'unactive': return '未激活';
                    default: return '';
                }
            }
        },
        methods: {

            initLocation() {
                this.$loaction.addListener(this.onLocationResult);
                if (this.$loaction.ret !== 'success') {
                    this.$loaction.getLocation();
                }
                this.locationRet = this.$loaction.ret;
            },

            handleControlButton() {
                if (!this.isOpening) {
                    this.netOpenDevice();
                }
            },

            handleRelocation() {
                this.$loaction.getLocation();
                this.locationRet = this.$loaction.ret;
            },

            startDeviceStatusTimer() {
                this.stopDeviceStatusTimer();
                this.statusTimer = setInterval(() => {
                    this.getDevice({
                        ignoreError: true
                    });
                }, 2000);
            },

            stopDeviceStatusTimer() {
                if (this.statusTimer) {
                    clearInterval(this.statusTimer);
                    this.statusTimer = null;
                }
            },

            startRunDurationTimer() {
                this.stopRunDurationTimer();
                this.updateRunDuration();
                this.durationTimer = setInterval(this.updateRunDuration, 1000);
            },

            updateRunDuration() {
                const duration = Math.floor(Math.max(new Date().getTime() - this.deviceStartTime, 0) / 1000);
                const min = Math.floor(duration / 60);
                const sec = duration - min * 60;
                if (min === 0) {
                    this.runDuration = sec + '秒';
                } else {
                    this.runDuration = min + '分' + sec + '秒';
                }
            },

            stopRunDurationTimer() {
                if (this.durationTimer) {
                    clearInterval(this.durationTimer);
                    this.durationTimer = null;
                }
            },

            onLocationResult(ret, longitude, latitude) {
                console.log(arguments);
                this.locationRet = ret;
                if (ret === 'success') {
                    this.netSetLocation(longitude, latitude);
                }
            },


            /**
             * 开启设备
             * @returns {Promise<void>}
             */
            async netOpenDevice() {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.openDevice({
                        memberId: this.curMember.id
                    });
                    this.getDevice().then((device) => {
                        this.runDuration = null;
                        this.deviceStartTime = device.lastOpenTime;
                        this.startRunDurationTimer();
                    });
                    this.getMembers();
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            async netSetLocation(longitude, latitude) {
                try {
                    await this.$req.setDeviceLocation({
                        longitude,
                        latitude
                    }, {
                        ignoreError: true
                    });
                } catch (e) {
                    //TODO
                }
            },

            ...mapActions([
                'getMembers',
                'getDevice'
            ])
        },
        mounted() {
            this.startDeviceStatusTimer();
            if (this.isOpening) {
                this.deviceStartTime = this.device.lastOpenTime;
                this.startRunDurationTimer();
            }
            this.initLocation();
        },
        beforeDestroy() {
            this.stopDeviceStatusTimer();
            this.stopRunDurationTimer();
            this.$loaction.removeListener(this.onLocationResult);
        }
    }
</script>